import Vue from 'vue/dist/vue.esm';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    example: ''
  },
  mutations: {
    setExample: (state, payload) => {
      state.example = payload;
      return state;
    }
  },
  actions: {
    setExample: (context, payload) => {
      context.commit('setExample', payload);
    }
  },
  getters: {
    example: (state) => {
      return false;
    }
  }
});

export default store;